import { AreaProperties, AreaFlags } from '@/infrastructure/network/Monitaro/schema/models'

export interface IAreaProps {
  id?: string
  name: string | null
  zeacon: string | null
  hospitalId: string | null
  properties: AreaProperties | null
  flags: AreaFlags | null
  createdAt: string | null
  updatedAt: string | null
}

export default class AreaEntity {
  private _props: IAreaProps

  constructor(props?: IAreaProps | null) {
    this._props = EmptyAreaPropsFactory(props)
  }

  get props(): IAreaProps {
    return this._props
  }

  get clone(): IAreaProps {
    return structuredClone(this._props)
  }

  get id(): string | undefined {
    return this._props.id
  }

  get name(): string | null {
    return this._props.name
  }

  get zeacon(): string | null {
    return this._props.zeacon
  }

  get hospitalId(): string | null {
    return this._props.hospitalId
  }

  get properties(): AreaProperties | null | undefined {
    return this._props.properties
  }

  get flags(): AreaFlags | null | undefined {
    return this._props.flags
  }

  get createdAt(): string | null {
    return this._props.createdAt
  }

  get updatedAt(): string | null {
    return this._props.updatedAt
  }
}

export const headers = [{ text: 'ID', value: 'id' }]

export const EmptyAreaPropsFactory = (props?: Partial<IAreaProps> | null): IAreaProps => ({
  name: null,
  zeacon: null,
  hospitalId: null,
  properties: null,
  flags: null,
  createdAt: null,
  updatedAt: null,
  ...props
})
